// generated by koharu; do not edit
// @ts-nocheck: generated bindings are checked by their Rust source, not by strict hosts.

// This file has been generated by Tauri Specta. Do not edit this file manually.

import { invoke as __TAURI_INVOKE, Channel } from "./transport";

/** Commands */
export const commands = {
	getAgentStatus: () => __TAURI_INVOKE<AgentStatus>("get_agent_status"),
	loginAgent: (onEvent: Channel<LoginEvent>) => __TAURI_INVOKE<AgentStatus>("login_agent", { onEvent }),
	logoutAgent: () => __TAURI_INVOKE<AgentStatus>("logout_agent"),
	saveAgentConfig: (config: Config) => __TAURI_INVOKE<Config>("save_agent_config", { config }),
	runAgent: (prompt: string, onEvent: Channel<Event>) => __TAURI_INVOKE<RunId>("run_agent", { prompt, onEvent }),
	cancelAgent: (run: RunId) => __TAURI_INVOKE<null>("cancel_agent", { run }),
	subscribe: (onCanvas: Channel<CanvasState>, onJob: Channel<Job>, onDownload: Channel<Download>, onResources: Channel<ModelResources>, onProject: Channel<{
	name: string,
	revision: Revision,
	active_page: EntityId | null,
	can_undo: boolean,
	can_redo: boolean,
} | null>) => __TAURI_INVOKE<StartupState>("subscribe", { onCanvas: mapChannel(onCanvas, (v) => ({...v,revision:v.revision==null?v.revision:v.revision})), onJob, onDownload, onResources: mapChannel(onResources, (v) => ({...v,devices:v.devices.map(i=>({...i,memory_budget:i.memory_budget==null?i.memory_budget:i.memory_budget,memory_used:i.memory_used==null?i.memory_used:i.memory_used,utilization:i.utilization==null?i.utilization:i.utilization}))})), onProject }).then((v) => (({...v,preferences:({...v.preferences,pipeline:({...v.preferences.pipeline,translation:({...v.preferences.pipeline.translation,generation:({...v.preferences.pipeline.translation.generation,temperature:v.preferences.pipeline.translation.generation.temperature==null?v.preferences.pipeline.translation.generation.temperature:v.preferences.pipeline.translation.generation.temperature,top_p:v.preferences.pipeline.translation.generation.top_p==null?v.preferences.pipeline.translation.generation.top_p:v.preferences.pipeline.translation.generation.top_p,min_p:v.preferences.pipeline.translation.generation.min_p==null?v.preferences.pipeline.translation.generation.min_p:v.preferences.pipeline.translation.generation.min_p,repeat_penalty:v.preferences.pipeline.translation.generation.repeat_penalty==null?v.preferences.pipeline.translation.generation.repeat_penalty:v.preferences.pipeline.translation.generation.repeat_penalty,frequency_penalty:v.preferences.pipeline.translation.generation.frequency_penalty==null?v.preferences.pipeline.translation.generation.frequency_penalty:v.preferences.pipeline.translation.generation.frequency_penalty,presence_penalty:v.preferences.pipeline.translation.generation.presence_penalty==null?v.preferences.pipeline.translation.generation.presence_penalty:v.preferences.pipeline.translation.generation.presence_penalty})}),processor:({...v.preferences.pipeline.processor,"koharu-layout-rfdetr-seg-2xl":v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]==null?v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]:({...v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"],text_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold==null?v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold,bubble_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold==null?v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold,panel_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold==null?v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold:v.preferences.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold})})})}),jobs:v.jobs.map(i=>i),canvas:({...v.canvas,revision:v.canvas.revision==null?v.canvas.revision:v.canvas.revision})}) as typeof v)),
	getProject: () => __TAURI_INVOKE<{
	name: string,
	revision: Revision,
	active_page: EntityId | null,
	can_undo: boolean,
	can_redo: boolean,
} | null>("get_project"),
	getPages: () => __TAURI_INVOKE<PageSummary[]>("get_pages").then((v) => (v.map(i=>i) as typeof v)),
	getPage: () => __TAURI_INVOKE<{
	id: EntityId,
	label: string,
	size: PageSize,
	layers: Layer[],
	regions: AnalysisRegion[],
} | null>("get_page").then((v) => (v==null?v:({...v,layers:v.layers.map(i=>i),regions:v.regions.map(i=>({...i,geometry:({...i.geometry,points:i.geometry.points.map(i=>i)})}))}) as typeof v)),
	listProjects: () => __TAURI_INVOKE<ProjectSummary[]>("list_projects"),
	createProject: (name: string) => __TAURI_INVOKE<null>("create_project", { name }),
	openProject: (name: string) => __TAURI_INVOKE<null>("open_project", { name }),
	deleteProject: (name: string) => __TAURI_INVOKE<null>("delete_project", { name }),
	closeProject: () => __TAURI_INVOKE<null>("close_project"),
	/**  Pick files or a folder in a native dialog, then import them. */
	import: (source: PageImportSource) => __TAURI_INVOKE<null>("import", { source }),
	selectPage: (page: EntityId) => __TAURI_INVOKE<PageSelection>("select_page", { page }).then((v) => (({...v,page:({...v.page,layers:v.page.layers.map(i=>i),regions:v.page.regions.map(i=>({...i,geometry:({...i.geometry,points:i.geometry.points.map(i=>i)})}))})}) as typeof v)),
	renamePage: (page: EntityId, label: string) => __TAURI_INVOKE<null>("rename_page", { page, label }),
	deletePages: (pages: EntityId[]) => __TAURI_INVOKE<null>("delete_pages", { pages }),
	movePage: (page: EntityId, index: number) => __TAURI_INVOKE<null>("move_page", { page, index }),
	setSourceText: (layer: EntityId, text: string) => __TAURI_INVOKE<null>("set_source_text", { layer, text }),
	setTranslation: (layer: EntityId, text: string | null) => __TAURI_INVOKE<null>("set_translation", { layer, text }),
	setTypography: (updates: TypographyUpdate[]) => __TAURI_INVOKE<null>("set_typography", { updates: updates.map(i=>({...i,typography:({...i.typography,size:i.typography.size==null?i.typography.size:i.typography.size,stroke_width:i.typography.stroke_width==null?i.typography.stroke_width:i.typography.stroke_width})})) }),
	setGeometry: (updates: GeometryUpdate[]) => __TAURI_INVOKE<null>("set_geometry", { updates: updates.map(i=>({...i,points:i.points==null?i.points:i.points.map(i=>i)})) }),
	setVisibility: (layers: EntityId[], visible: boolean | null, opacity: number | null) => __TAURI_INVOKE<null>("set_visibility", { layers, visible, opacity: opacity==null?opacity:opacity }),
	deleteLayers: (layers: EntityId[]) => __TAURI_INVOKE<null>("delete_layers", { layers }),
	moveLayer: (layer: EntityId, parent: EntityId, index: number) => __TAURI_INVOKE<Page>("move_layer", { layer, parent, index }).then((v) => (({...v,layers:v.layers.map(i=>i),regions:v.regions.map(i=>({...i,geometry:({...i.geometry,points:i.geometry.points.map(i=>i)})}))}) as typeof v)),
	undo: () => __TAURI_INVOKE<null>("undo"),
	redo: () => __TAURI_INVOKE<null>("redo"),
	process: (scope: Scope, operation: Operation) => __TAURI_INVOKE<JobId>("process", { scope, operation }),
	stopJob: (job: JobId) => __TAURI_INVOKE<null>("stop_job", { job }),
	/**  Pick the destination in a native dialog, then export every page. */
	export: (format: ExportFormat) => __TAURI_INVOKE<null>("export", { format }),
	getThumbnail: (page: EntityId) => __TAURI_INVOKE<ThumbnailBytes>("get_thumbnail", { page }),
	/**
	 *  Typed model output of a page (regions, texts, cleanup layer, provenance), as the Shenron
	 *  chain maps it into manga candidates.
	 */
	getPageResult: (page: EntityId) => __TAURI_INVOKE<PageResult>("get_page_result", { page }).then((v) => (({...v,regions:v.regions.map(i=>({...i,polygon:i.polygon.map(i=>i),bounds:i.bounds.map(i=>i),detection_labels:i.detection_labels.map(i=>i),confidence:i.confidence==null?i.confidence:i.confidence,detection_provenance:i.detection_provenance==null?i.detection_provenance:({...i.detection_provenance,confidence:i.detection_provenance.confidence==null?i.detection_provenance.confidence:i.detection_provenance.confidence}),texts:i.texts.map(i=>({...i,reading_order:i.reading_order==null?i.reading_order:i.reading_order,ocr_confidence:i.ocr_confidence==null?i.ocr_confidence:i.ocr_confidence,ocr_provenance:i.ocr_provenance==null?i.ocr_provenance:({...i.ocr_provenance,confidence:i.ocr_provenance.confidence==null?i.ocr_provenance.confidence:i.ocr_provenance.confidence}),translation_provenance:i.translation_provenance==null?i.translation_provenance:({...i.translation_provenance,confidence:i.translation_provenance.confidence==null?i.translation_provenance.confidence:i.translation_provenance.confidence})}))})),cleanup_provenance:v.cleanup_provenance==null?v.cleanup_provenance:({...v.cleanup_provenance,confidence:v.cleanup_provenance.confidence==null?v.cleanup_provenance.confidence:v.cleanup_provenance.confidence})}) as typeof v)),
	/**  SHA-256 of the source image bytes stored for a page. */
	getPageSourceSha256: (page: EntityId) => __TAURI_INVOKE<string>("get_page_source_sha256", { page }),
	getFonts: () => __TAURI_INVOKE<FontFamily[]>("get_fonts"),
	getFontPreview: (familyName: string) => __TAURI_INVOKE<FontPreviewBytes>("get_font_preview", { familyName }),
	savePreferences: (pipeline: PipelineConfig, providers: ProviderPreferences, typesetting: TypesettingConfig) => __TAURI_INVOKE<Preferences>("save_preferences", { pipeline: ({...pipeline,translation:({...pipeline.translation,generation:({...pipeline.translation.generation,temperature:pipeline.translation.generation.temperature==null?pipeline.translation.generation.temperature:pipeline.translation.generation.temperature,top_p:pipeline.translation.generation.top_p==null?pipeline.translation.generation.top_p:pipeline.translation.generation.top_p,min_p:pipeline.translation.generation.min_p==null?pipeline.translation.generation.min_p:pipeline.translation.generation.min_p,repeat_penalty:pipeline.translation.generation.repeat_penalty==null?pipeline.translation.generation.repeat_penalty:pipeline.translation.generation.repeat_penalty,frequency_penalty:pipeline.translation.generation.frequency_penalty==null?pipeline.translation.generation.frequency_penalty:pipeline.translation.generation.frequency_penalty,presence_penalty:pipeline.translation.generation.presence_penalty==null?pipeline.translation.generation.presence_penalty:pipeline.translation.generation.presence_penalty})}),processor:({...pipeline.processor,"koharu-layout-rfdetr-seg-2xl":pipeline.processor["koharu-layout-rfdetr-seg-2xl"]==null?pipeline.processor["koharu-layout-rfdetr-seg-2xl"]:({...pipeline.processor["koharu-layout-rfdetr-seg-2xl"],text_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold==null?pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold,bubble_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold==null?pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold,panel_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold==null?pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold:pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold})})}), providers, typesetting }).then((v) => (({...v,pipeline:({...v.pipeline,translation:({...v.pipeline.translation,generation:({...v.pipeline.translation.generation,temperature:v.pipeline.translation.generation.temperature==null?v.pipeline.translation.generation.temperature:v.pipeline.translation.generation.temperature,top_p:v.pipeline.translation.generation.top_p==null?v.pipeline.translation.generation.top_p:v.pipeline.translation.generation.top_p,min_p:v.pipeline.translation.generation.min_p==null?v.pipeline.translation.generation.min_p:v.pipeline.translation.generation.min_p,repeat_penalty:v.pipeline.translation.generation.repeat_penalty==null?v.pipeline.translation.generation.repeat_penalty:v.pipeline.translation.generation.repeat_penalty,frequency_penalty:v.pipeline.translation.generation.frequency_penalty==null?v.pipeline.translation.generation.frequency_penalty:v.pipeline.translation.generation.frequency_penalty,presence_penalty:v.pipeline.translation.generation.presence_penalty==null?v.pipeline.translation.generation.presence_penalty:v.pipeline.translation.generation.presence_penalty})}),processor:({...v.pipeline.processor,"koharu-layout-rfdetr-seg-2xl":v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]:({...v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"],text_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold,bubble_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold,panel_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold})})})}) as typeof v)),
	getPreferences: () => __TAURI_INVOKE<Preferences>("get_preferences").then((v) => (({...v,pipeline:({...v.pipeline,translation:({...v.pipeline.translation,generation:({...v.pipeline.translation.generation,temperature:v.pipeline.translation.generation.temperature==null?v.pipeline.translation.generation.temperature:v.pipeline.translation.generation.temperature,top_p:v.pipeline.translation.generation.top_p==null?v.pipeline.translation.generation.top_p:v.pipeline.translation.generation.top_p,min_p:v.pipeline.translation.generation.min_p==null?v.pipeline.translation.generation.min_p:v.pipeline.translation.generation.min_p,repeat_penalty:v.pipeline.translation.generation.repeat_penalty==null?v.pipeline.translation.generation.repeat_penalty:v.pipeline.translation.generation.repeat_penalty,frequency_penalty:v.pipeline.translation.generation.frequency_penalty==null?v.pipeline.translation.generation.frequency_penalty:v.pipeline.translation.generation.frequency_penalty,presence_penalty:v.pipeline.translation.generation.presence_penalty==null?v.pipeline.translation.generation.presence_penalty:v.pipeline.translation.generation.presence_penalty})}),processor:({...v.pipeline.processor,"koharu-layout-rfdetr-seg-2xl":v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"]:({...v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"],text_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].text_threshold,bubble_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].bubble_threshold,panel_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold==null?v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold:v.pipeline.processor["koharu-layout-rfdetr-seg-2xl"].panel_threshold})})})}) as typeof v)),
	getTranslationModels: () => __TAURI_INVOKE<Model[]>("get_translation_models"),
	getCanvasManifest: (generation: CanvasGeneration) => __TAURI_INVOKE<CanvasBytes>("get_canvas_manifest", { generation }),
	getCanvasResource: (generation: CanvasGeneration, resource: string) => __TAURI_INVOKE<CanvasBytes>("get_canvas_resource", { generation, resource }),
	prepareCanvasPage: (page: EntityId) => __TAURI_INVOKE<{
	revision: Revision,
	page: Page,
} | null>("prepare_canvas_page", { page }).then((v) => (v==null?v:({...v,page:({...v.page,layers:v.page.layers.map(i=>i),regions:v.page.regions.map(i=>({...i,geometry:({...i.geometry,points:i.geometry.points.map(i=>i)})}))})}) as typeof v)),
	getCanvasPageManifest: (page: EntityId, revision: Revision) => __TAURI_INVOKE<CanvasBytes>("get_canvas_page_manifest", { page, revision }),
	getCanvasPageResource: (page: EntityId, revision: Revision, resource: string) => __TAURI_INVOKE<CanvasBytes>("get_canvas_page_resource", { page, revision, resource }),
	addPointText: (point: Point) => __TAURI_INVOKE<LayerCommit>("add_point_text", { point }),
	addTextBox: (frame: Frame) => __TAURI_INVOKE<LayerCommit>("add_text_box", { frame }),
	commitPaint: (expectedRevision: Revision, layer: string | null, points: Point[], brush: PaintBrush) => __TAURI_INVOKE<LayerCommit>("commit_paint", { expectedRevision, layer, points: points.map(i=>i), brush }),
	commitErase: (expectedRevision: Revision, layer: EntityId, points: Point[], diameter: number) => __TAURI_INVOKE<LayerCommit>("commit_erase", { expectedRevision, layer, points: points.map(i=>i), diameter }),
	commitTransform: (expectedRevision: Revision, elements: TransformFrame[]) => __TAURI_INVOKE<number | null>("commit_transform", { expectedRevision, elements }).then((v) => (v==null?v:v as typeof v)),
	commitInpaint: (expectedRevision: Revision, points: Point[], diameter: number) => __TAURI_INVOKE<string | null>("commit_inpaint", { expectedRevision, points: points.map(i=>i), diameter }),
};

/* Types */
export type Account = {
	id: string,
	email: string | null,
	plan: string | null,
};

export type AgentStatus = {
	account: Account | null,
	models: CodexModel[],
	config: Config,
	running: RunId | null,
};

export type AnalysisRegion = {
	id: EntityId,
	parent: EntityId | null,
	geometry: Geometry,
	kind: string,
	label: string | null,
};

export type Bounds = {
	x: number,
	y: number,
	width: number,
	height: number,
};

export type CaiyunConfig = Record<string, never>;

/**  Prepared canvas manifest or resource packet. */
export type CanvasBytes = number[];

export type CanvasGeneration = number;

export type CanvasPagePreparation = {
	revision: Revision,
	page: Page,
};

export type CanvasState = {
	page: EntityId | null,
	revision: Revision | null,
	generation: number,
	size: [number, number],
	element_frames: TransformFrame[],
};

export type ClaudeConfig = Record<string, never>;

export type CodexModel = {
	id: string,
	name: string,
	reasoning: Reasoning[],
};

export type Config = {
	model: string | null,
	reasoning: Reasoning,
};

export type CredentialInput = {
	configured: boolean,
	value: string | null,
	clear: boolean,
};

export type DeepLConfig = {
	base_url?: string | null,
};

export type DeepSeekConfig = Record<string, never>;

export type DetectionLabel = {
	kind: RegionKind,
	confidence: number,
};

export type DetectionModel = {
	model: "koharu-layout-rfdetr-seg-2xl",
} & KoharuLayoutRFDetrSeg2XLConfig;

export type DeviceResources = {
	name: string,
	selected: boolean,
	memory_budget: number | null,
	memory_used: number | null,
	utilization: number | null,
};

export type Download = {
	id: number,
	state: DownloadState,
	name: string | null,
	completed: number,
	total: number,
	error: string | null,
};

export type DownloadState = "running" | "finished" | "failed";

export type EntityId = string;

export type Error = string;

export type Event = { type: "started"; run: RunId } | { type: "text_delta"; run: RunId; delta: string } | { type: "reasoning_delta"; run: RunId; delta: string } | { type: "tool_started"; run: RunId; call_id: string; name: string } | { type: "tool_finished"; run: RunId; call_id: string; name: string; changed: boolean; output: string } | { type: "completed"; run: RunId; message: string } | { type: "failed"; run: RunId; message: string } | { type: "cancelled"; run: RunId };

export type ExportFormat = "png" | "psd" | "cbz";

export type Flux2KleinConfig = {
	prompt?: string,
};

export type FontFace = {
	postscript_name: string,
	weight: number,
	weight_range: FontRange | null,
	style: FontStyle,
};

export type FontFamily = {
	name: string,
	metadata: FontMetadata,
	sources: FontSource[],
	faces: FontFace[],
};

export type FontMetadata = {
	primary_script: string | null,
	scripts: string[],
	languages: string[],
	category: string | null,
	classifications: string[],
	use_cases: string[],
};

/**  Rendered font sample. */
export type FontPreviewBytes = number[];

export type FontRange = {
	minimum: number,
	maximum: number,
};

export type FontSource = "system" | "bundled";

export type FontStyle = "normal" | "italic" | "oblique";

export type Frame = {
	x: number,
	y: number,
	width: number,
	height: number,
	angle_degrees: number,
};

export type GeminiConfig = Record<string, never>;

export type GenerationConfig = {
	temperature?: number | null,
	top_k?: number | null,
	top_p?: number | null,
	min_p?: number | null,
	max_tokens?: number | null,
	repeat_penalty?: number | null,
	frequency_penalty?: number | null,
	presence_penalty?: number | null,
	reasoning?: boolean | null,
	vision?: boolean | null,
};

/**  Provenance recorded on a generated scene component. */
export type GenerationInfo = {
	producer: string,
	model: string | null,
	confidence: number | null,
};

export type Geometry = {
	points: Point[],
};

export type GeometryUpdate = {
	layer: EntityId,
	points: Point[] | null,
};

export type GoogleCloudConfig = Record<string, never>;

export type GrokConfig = Record<string, never>;

export type GroupRole = "text";

export type InpaintingModel = { model: "lama" } | { model: "aot-inpainting" } | {
	model: "flux2-klein",
} & Flux2KleinConfig | {
	model: "rorem-mixed",
} & RoremMixedConfig;

export type Job = {
	id: JobId,
	state: JobState,
	completed: number,
	total: number,
	page: EntityId | null,
	stage: Stage | null,
	model: string | null,
	error: string | null,
};

export type JobId = string;

export type JobState = "running" | "finished" | "failed" | "stopped";

export type KoharuLayoutRFDetrSeg2XLConfig = {
	text_threshold?: number | null,
	bubble_threshold?: number | null,
	panel_threshold?: number | null,
};

export type LanguageChoice = {
	tag: string,
	name: string,
};

export type Layer = { type: "group"; id: EntityId; parent: EntityId | null; visibility: LayerVisibility; name: string; role: GroupRole | null } | { type: "text"; id: EntityId; parent: EntityId | null; geometry: Geometry | null; angle_degrees: number | null; visibility: LayerVisibility; content: TextContent; typography: Typography | null; layout: TextLayoutKind; automatic_region: EntityId | null } | { type: "raster"; id: EntityId; parent: EntityId | null; visibility: LayerVisibility; image: string | null; name: string; kind: RasterLayerKind } | { type: "image"; id: EntityId; parent: EntityId | null; geometry: Geometry; visibility: LayerVisibility; image: string } | { type: "artwork"; id: EntityId; parent: EntityId | null; geometry: Geometry; visibility: LayerVisibility; image: string };

export type LayerCommit = {
	revision: Revision,
	layer: EntityId,
};

export type LayerVisibility = {
	visible: boolean,
	opacity: number,
};

export type LmStudioConfig = {
	base_url?: string | null,
};

export type LocalConfig = Record<string, never>;

export type LoginEvent = { type: "progress"; message: string } | { type: "device_code"; verification_url: string; user_code: string };

export type MiniMaxConfig = Record<string, never>;

export type Model = {
	provider: Provider,
	model: string | null,
	name: string,
	quantizations: Quantization[],
	vision: boolean,
	reasoning: boolean,
};

export type ModelResources = {
	process_memory: number,
	system_memory: number,
	process_cpu: number,
	devices: DeviceResources[],
};

export type ModelSelection = {
	provider: Provider,
	model?: string | null,
	quantization?: string | null,
	vision?: boolean,
	reasoning?: boolean,
};

export type OcrModel = { model: "paddleocr-vl-1.6" } | { model: "manga-ocr" } | { model: "baberu-ocr" } | { model: "hayai-ocr" };

export type OpenAiCompatibleConfig = {
	base_url?: string | null,
};

export type OpenAiConfig = Record<string, never>;

export type OpenRouterConfig = Record<string, never>;

export type Operation = { operation: "full" } | { operation: "through"; stage: Stage } | { operation: "only"; stage: Stage } | { operation: "stages"; stages: Stage[] };

export type Page = {
	id: EntityId,
	label: string,
	size: PageSize,
	layers: Layer[],
	regions: AnalysisRegion[],
};

export type PageImportSource = "files" | "folder";

/**  One page's source dimensions, detected regions, and optional cleanup overlay. */
export type PageResult = {
	page: EntityId,
	width: number,
	height: number,
	regions: RegionResult[],
	/**  Full-page transparent PNG layer produced by inpainting, when present. */
	cleanup_layer_png: number[] | null,
	cleanup_provenance: GenerationInfo | null,
};

export type PageSelection = {
	project: ProjectInfo,
	page: Page,
};

export type PageSize = {
	width: number,
	height: number,
};

export type PageSummary = {
	id: EntityId,
	label: string,
	size: PageSize,
	source_asset: string | null,
	layer_count: number,
};

export type PaintBrush = {
	diameter: number,
	color: [number, number, number, number],
};

export type PipelineConfig = {
	detection: DetectionModel,
	ocr: OcrModel,
	translation: TranslationConfig,
	inpainting: InpaintingModel,
	/**
	 *  Settings for every model are kept independently of the active model.
	 *  The active stage fields above only select which profile is used.
	 */
	processor: ProcessorConfig,
};

export type Point = {
	x: number,
	y: number,
};

export type Preferences = {
	pipeline: PipelineConfig,
	providers: ProviderPreferences,
	typesetting: TypesettingConfig,
	languages: LanguageChoice[],
};

export type ProcessorConfig = {
	"koharu-layout-rfdetr-seg-2xl"?: KoharuLayoutRFDetrSeg2XLConfig | null,
	"flux2-klein"?: Flux2KleinConfig | null,
	"rorem-mixed"?: RoremMixedConfig | null,
};

export type ProjectInfo = {
	name: string,
	revision: Revision,
	active_page: EntityId | null,
	can_undo: boolean,
	can_redo: boolean,
};

export type ProjectSummary = {
	name: string,
};

export type Provider = "local" | "openai" | "gemini" | "claude" | "grok" | "minimax" | "deepseek" | "openai-compatible" | "openrouter" | "lm-studio" | "deepl" | "google-cloud-translation" | "caiyun";

export type ProviderConfig = { provider: "local"; settings: LocalConfig } | { provider: "openai"; settings: OpenAiConfig } | { provider: "gemini"; settings: GeminiConfig } | { provider: "claude"; settings: ClaudeConfig } | { provider: "grok"; settings: GrokConfig } | { provider: "minimax"; settings: MiniMaxConfig } | { provider: "deepseek"; settings: DeepSeekConfig } | { provider: "openai-compatible"; settings: OpenAiCompatibleConfig } | { provider: "openrouter"; settings: OpenRouterConfig } | { provider: "lm-studio"; settings: LmStudioConfig } | { provider: "deepl"; settings: DeepLConfig } | { provider: "google-cloud-translation"; settings: GoogleCloudConfig } | { provider: "caiyun"; settings: CaiyunConfig };

export type ProviderPreference = {
	name: string,
	config: ProviderConfig,
	credential: CredentialInput | null,
};

export type ProviderPreferences = {
	entries: ProviderPreference[],
};

export type Quantization = {
	id: string,
	name: string,
	downloaded: boolean,
};

export type RasterLayerKind = "cleanup" | "paint";

export type Reasoning = "low" | "medium" | "high" | "xhigh" | "max" | "ultra";

export type RegionKind = string;

/**  A scene region with original polygon and its linked recognized text. */
export type RegionResult = {
	id: EntityId,
	kind: string,
	label: string | null,
	/**  Same shape as the project `Point` the editor exports (one name per type for Specta). */
	polygon: Point[],
	/**  Minimum x/y and maximum x/y in source page coordinates. */
	bounds: [number, number, number, number],
	detection_labels: DetectionLabel[],
	confidence: number | null,
	detection_provenance: GenerationInfo | null,
	texts: TextResult[],
};

export type Revision = number;

export type RoremMixedConfig = {
	prompt?: string,
	negative_prompt?: string,
};

export type RunId = string;

export type Scope = { scope: "project" } | { scope: "pages"; value: EntityId[] } | { scope: "region"; value: {
	page: EntityId,
	bounds: Bounds,
} } | { scope: "entities"; value: EntityId[] };

export type SourceText = {
	text: string,
	language: string | null,
};

export type Stage = "detection" | "ocr" | "translation" | "inpainting";

export type StartupState = {
	preferences: Preferences,
	jobs: Job[],
	canvas: CanvasState,
};

export type TextAlignment = "Start" | "Center" | "End" | "Justify";

export type TextContent = {
	id: EntityId,
	source: SourceText | null,
	translation: Translation | null,
	role: string | null,
	source_region: EntityId | null,
};

export type TextLayoutKind = "point" | "paragraph";

/**  Semantic text linked to a detected region through `RecognizedFrom`. */
export type TextResult = {
	id: EntityId,
	reading_order: number | null,
	source: string | null,
	source_language: string | null,
	ocr_confidence: number | null,
	ocr_provenance: GenerationInfo | null,
	translation: string | null,
	target_language: string | null,
	translation_provenance: GenerationInfo | null,
};

/**  WebP thumbnail of a page source. */
export type ThumbnailBytes = number[];

export type TransformFrame = {
	element: EntityId,
	frame: Frame,
};

export type Translation = {
	text: string,
	language: string | null,
};

export type TranslationConfig = {
	model: ModelSelection,
	generation: GenerationConfig,
	target_language: string,
	instructions: string | null,
};

export type TypesettingConfig = {
	font_families?: string[],
};

export type Typography = {
	preferred_font: string | null,
	font_weight: number | null,
	font_style: FontStyle | null,
	size: number | null,
	auto_fit: boolean,
	color: [number, number, number, number] | null,
	stroke_color: [number, number, number, number] | null,
	stroke_width: number | null,
	alignment: TextAlignment | null,
	writing_mode: WritingMode | null,
};

export type TypographyUpdate = {
	layer: EntityId,
	typography: Typography,
};

export type WritingMode = "Horizontal" | "Vertical";

/* Tauri Specta runtime */
function mapChannel<T>(channel: Channel<T>, deserialize: (payload: any) => T): Channel<T> {
    return new Channel((payload) => channel.onmessage(deserialize(payload)));
}


export { Channel };
